// extracted by mini-css-extract-plugin
export var card = "_94-1";
export var container = "_94-0";